import { render } from "./BaseGridColumnHeader.vue?vue&type=template&id=1cc3af2d"
import script from "./BaseGridColumnHeader.vue?vue&type=script&lang=js"
export * from "./BaseGridColumnHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__